export const setDialog = 'SET_DIALOG';
export const setSnackbar = 'SET_SNACKBAR';
export const setUser = 'SET_USER';
